import Service from "./Service"

class GlobalPaymentModifierService extends Service {

    findById = (id) => this.get(`/global-payment-modifiers/${id}`)

    findAll = (queryParams) => this.getWithParams("/global-payment-modifiers", queryParams)

    updateGlobalPaymentModifier = (taskTypeId, requestBody) => this.patch(`/global-payment-modifiers/${taskTypeId}`, requestBody)
}
const globalPaymentModifierService = new GlobalPaymentModifierService()
export default globalPaymentModifierService